(function ($) { // Self Executing function with $ alias for jQuery

    /**
     *  Initialization  similar to include once but since all js is loaded by the browser automatically the all
     *   we have to do is call our functions to initialize them, his is only run in the main configuration file
     */
    $(document).ready(function () {

        if ($('#uo-group-assignments-table').length > 0 ){
            window.ulgmGroupManagement.Assignments.constructor();

            jQuery('form#uo-groups-assignments-management-form').on('click', 'button.assignment_approve_single,a.assignment_approve_single,button#group-approve-assignments-button', function (e) {
                e.preventDefault();
                var assignment_id = jQuery(this).attr('id').replace('assignment_approve_', '');
                assignment_id = assignment_id.replace('a_', '');
                if ((typeof assignment_id !== 'undefined') && (assignment_id != '')) {
                    if (jQuery('form#uo-groups-assignments-management-form input#bulk-post-selector-top').length) {
                        jQuery('form#uo-groups-assignments-management-form input#bulk-post-selector-top').val(assignment_id);
                    }
                    if (jQuery('form#uo-groups-assignments-management-form input#bulk-action-selector-top').length) {
                        jQuery('form#uo-groups-assignments-management-form input#bulk-action-selector-top').val('approve_assignment');
                    }
                    var dataVars = $('form#uo-groups-assignments-management-form').serialize();
                    window.ulgmGroupManagement.Assignments.actionsAssignment(dataVars);
                }
            });
            jQuery('form#uo-groups-assignments-management-form').on('click','a.delete_assignment_single,button#group-trash-assignments-button',function(e) {
                e.preventDefault();
                var assignment_id = jQuery(this).attr('id').replace('a_assignment_trash_', '');

                if ( ( typeof assignment_id !== 'undefined' ) && ( assignment_id != '' ) ) {
                    if (jQuery('form#uo-groups-assignments-management-form input#bulk-post-selector-top').length) {
                        jQuery('form#uo-groups-assignments-management-form input#bulk-post-selector-top').val(assignment_id);
                    }
                    if (jQuery('form#uo-groups-assignments-management-form input#bulk-action-selector-top').length) {
                        jQuery('form#uo-groups-assignments-management-form input#bulk-action-selector-top').val('trash_assignment');
                    }
                    var dataVars = $('form#uo-groups-assignments-management-form').serialize();
                    window.ulgmGroupManagement.Assignments.actionsAssignment(dataVars);
                }
            });


            $('#uo-group-assignments-table').on('click','a.edit_assignment_single',function(){
                var post_id = $(this).data('assignment-id');
                window.ulgmGroupManagement.Assignments.editAssignmentsData(post_id);
            });
            $('body').on('click','button#uo-assignment-edit-button',function(){
                window.ulgmGroupManagement.Assignments.saveAssignmentsData();
            });
            $('body').on('click','#uo-assignment-update-button',function(){
                window.ulgmGroupManagement.Assignments.saveAssignmentsData();
            });

            var transitionTimeout;
            $( '#uo-group-assignments-table tbody' ).on({
                mouseenter: function() {
                    clearTimeout( transitionTimeout );
                    focusedRowActions = $( this ).find( '.row-actions' );
                    // transitionTimeout is necessary for Firefox, but Chrome won't remove the CSS class without a little help.
                    $( '.row-actions' ).not( this ).removeClass( 'visible' );
                    focusedRowActions.addClass( 'visible' );
                },
                mouseleave: function() {
                    // Tabbing between post title and .row-actions links needs a brief pause, otherwise
                    // the .row-actions div gets hidden in transit in some browsers (ahem, Firefox).
                    transitionTimeout = setTimeout( function() {
                        focusedRowActions.removeClass( 'visible' );
                    }, 30 );
                }
            }, 'tr' );
        }
    });


    window.ulgmGroupManagement.Assignments = {

        uoTable: null,

        uoTableHidden: null,

        lessonId: 0,

        groupId: 0,

        courseId: 0,

        status: 'not-approved',

        elements: {
            select: {
                group: {
                    element: null,
                    options: null
                },
                course: {
                    element: null,
                    options: null,
                    no_element: null
                },
                lesson: {
                    element: null,
                    options: null,
                    no_element: null
                },
                status: {
                    element: null,
                    options: null,
                },
            }
        },

        constructor: function () {
            this.elements.select.group.element  = $('#uo-group-report-group');
            this.elements.select.course.element = $('#uo-group-report-courses');
            this.elements.select.lesson.element   = $('#uo-group-report-lessons');
            this.elements.select.status.element   = $('#uo-group-report-status');


            this.elements.select.course.no_element = $('#uo-group-report-nocourses');
            this.elements.select.lesson.no_element   = $('#uo-group-report-nolessons');

            this.elements.select.group.options  = $('#uo-group-report-group option');
            this.elements.select.course.options = $('#uo-group-report-courses option');
            this.elements.select.lesson.options   = $('#uo-group-report-lessons option');
            this.elements.select.status.options   = $('#uo-group-report-status option');

            this.createTable();
            this.createTableHidden();
            this.addEvents();
            window.ulgmGroupManagement.Assignments.status = this.elements.select.status.element.val();
            // Request data
            window.ulgmGroupManagement.Assignments.getAssignmentsData( 0, 0, window.ulgmGroupManagement.Assignments.groupId, window.ulgmGroupManagement.Assignments.status );
        },

        createTable: function (data) {

            const $table = document.getElementById( 'uo-group-assignments-table' );

            var columns = [
                {
                    title: 'select',
                    className: 'ulg-report-cell ulg-report-assignments-cell ulg-report-assignments-cell--select-row',
                },
                {
                    title: groupAssignments.localized.title,
                    data: 'title',
                    className: 'has-row-actions',
                    name: 'title',
                    visible: groupAssignments.columns_visibilities.title,
                    className: 'ulg-report-cell ulg-report-assignments-cell ulg-report-assignments-cell--title',
                },
				{
                    title: groupAssignments.localized.student,
                    data: 'student',
                    name: 'student',
                    visible: groupAssignments.columns_visibilities.student,
                    className: 'ulg-report-cell ulg-report-assignments-cell ulg-report-assignments-cell--student',
                },
                {
                    title: groupAssignments.localized.first_name,
                    data: 'first_name',
                    name: 'first_name',
                    visible: groupAssignments.columns_visibilities.first_name,
                    className: 'ulg-report-cell ulg-report-assignments-cell ulg-report-assignments-cell--first-name',
                },
                {
                    title: groupAssignments.localized.last_name,
                    data: 'last_name',
                    name: 'last_name',
                    visible: groupAssignments.columns_visibilities.last_name,
                    className: 'ulg-report-cell ulg-report-assignments-cell ulg-report-assignments-cell--last-name',
                },
                {
                    title: groupAssignments.localized.author,
                    data: 'author',
                    name: 'author',
                    visible: groupAssignments.columns_visibilities.author,
                    className: 'ulg-report-cell ulg-report-assignments-cell ulg-report-assignments-cell--author',
                },
                {
                    title: groupAssignments.localized.status,
                    data: 'status',
                    orderable: true,
                    name: 'status',
                    visible: groupAssignments.columns_visibilities.status,
                    className: 'ulg-report-cell ulg-report-assignments-cell ulg-report-assignments-cell--status',
                },
                {
                    title: groupAssignments.localized.points,
                    data: 'points',
                    orderable: false,
                    name: 'points',
                    visible: groupAssignments.columns_visibilities.points,
                    className: 'ulg-report-cell ulg-report-assignments-cell ulg-report-assignments-cell--points',
                },
                {
                    title: groupAssignments.localized.assignedCourse,
                    data: 'assignedCourse',
                    orderable: true,
                    name: 'assignedCourse',
                    visible: groupAssignments.columns_visibilities.assignedCourse,
                    className: 'ulg-report-cell ulg-report-assignments-cell ulg-report-assignments-cell--assigned-course',
                },
                {
                    title: groupAssignments.localized.assignedlesson,
                    data: 'assignedlesson',
                    orderable: true,
                    name: 'assignedlesson',
                    visible: groupAssignments.columns_visibilities.assignedlesson,
                    className: 'ulg-report-cell ulg-report-assignments-cell ulg-report-assignments-cell--assigned-lesson',
                },
                {
                    title: groupAssignments.localized.comments,
                    data: 'comments',
                    name: 'comments',
                    visible: groupAssignments.columns_visibilities.comments,
                    className: 'ulg-report-cell ulg-report-assignments-cell ulg-report-assignments-cell--comments',
                },
                {
                    title: groupAssignments.localized.date,
                    data: 'date',
                    name: 'date',
                    visible: groupAssignments.columns_visibilities.date,
                    className: 'ulg-report-cell ulg-report-assignments-cell ulg-report-assignments-cell--date',
                },
            ];

            let exportButtons = [];
            if ($table.dataset.csv == 'show') {
                exportButtons.push({
                    extend: 'csv',
                    text: groupAssignments.i18n.exportCSV
                });
            }
            if ($table.dataset.excel == 'show') {
                exportButtons.push({
                    extend: 'excelHtml5',
                    text: groupAssignments.i18n.exportExcel
                });
            }

            var tableVars = {
                aLengthMenu: [
                    [15, 30, 60, -1],
                    [15, 30, 60, groupAssignments.localized.all]
                ],
                responsive: true,
                iDisplayLength: 30,
                columns: columns,
                columnDefs: [{
                    "targets": 0,
                    "orderable": false,
                    "searchable": false,
                    'render': function (data, type, full, meta){
                        return '<input type="checkbox" name="post[]" value="' + $('<div/>').text(data).html() + '">';
                    },
                    'checkboxes': {
                        'selectRow': true
                    }
                }],
                select: {
                    style: 'multi',
                    selector: 'td:first-child'
                },
                stateSave: true,
                //responsive: true,

                dom: '<"uo-groups-datatable-header"B>frt<"uo-groups-datatable-footer"lpi>',
                buttons: exportButtons,

            };

            if (null !== this.uoTable) {

                this.uoTable.destroy();

                tableVars.data = data;

                tableVars.columns = [
                    {
                        title: '<input type="checkbox" name="select_all" value="1" id="uo-assignments-select-all">',
                        data: 'id',
                        className: 'ulg-report-cell ulg-report-assignments-cell ulg-report-assignments-cell--select-row',
                    },
                    {
                        title: groupAssignments.localized.title,
                        data: 'title',
                        className: 'has-row-actions',
                        name: 'title',
                        visible: groupAssignments.columns_visibilities.title,
                        className: 'ulg-report-cell ulg-report-assignments-cell ulg-report-assignments-cell--title',
                    },
					{
						title: groupAssignments.localized.student,
						data: 'student',
						name: 'student',
						visible: groupAssignments.columns_visibilities.student,
						className: 'ulg-report-cell ulg-report-assignments-cell ulg-report-assignments-cell--student',
					},
                    {
                        title: groupAssignments.localized.first_name,
                        data: 'first_name',
                        name: 'first_name',
                        visible: groupAssignments.columns_visibilities.first_name,
                        className: 'ulg-report-cell ulg-report-assignments-cell ulg-report-assignments-cell--first-name',
                    },
                    {
                        title: groupAssignments.localized.last_name,
                        data: 'last_name',
                        name: 'last_name',
                        visible: groupAssignments.columns_visibilities.last_name,
                        className: 'ulg-report-cell ulg-report-assignments-cell ulg-report-assignments-cell--last-name',
                    },
                    {
                        title: groupAssignments.localized.author,
                        data: 'author',
                        name: 'author',
                        visible: groupAssignments.columns_visibilities.author,
                        className: 'ulg-report-cell ulg-report-assignments-cell ulg-report-assignments-cell--author',
                    },
                    {
                        title: groupAssignments.localized.status,
                        data: 'status',
                        orderable: true,
                        name: 'status',
                        visible: groupAssignments.columns_visibilities.status,
                        className: 'ulg-report-cell ulg-report-assignments-cell ulg-report-assignments-cell--status',
                    },
                    {
                        title: groupAssignments.localized.points,
                        data: 'points',
                        orderable: false,
                        name: 'points',
                        visible: groupAssignments.columns_visibilities.points,
                        className: 'ulg-report-cell ulg-report-assignments-cell ulg-report-assignments-cell--points',
                    },
                    {
                        title: groupAssignments.localized.assignedCourse,
                        data: 'assignedCourse',
                        orderable: true,
                        name: 'assignedCourse',
                        visible: groupAssignments.columns_visibilities.assignedCourse,
                        className: 'ulg-report-cell ulg-report-assignments-cell ulg-report-assignments-cell--assigned-course',
                    },
                    {
                        title: groupAssignments.localized.assignedlesson,
                        data: 'assignedlesson',
                        orderable: true,
                        name: 'assignedlesson',
                        visible: groupAssignments.columns_visibilities.assignedlesson,
                        className: 'ulg-report-cell ulg-report-assignments-cell ulg-report-assignments-cell--assigned-lesson',
                    },
                    {
                        title: groupAssignments.localized.comments,
                        data: 'comments',
                        name: 'comments',
                        visible: groupAssignments.columns_visibilities.comments,
                        className: 'ulg-report-cell ulg-report-assignments-cell ulg-report-assignments-cell--comments',
                    },
                    {
                        title: groupAssignments.localized.date,
                        data: 'date',
                        name: 'date',
                        visible: groupAssignments.columns_visibilities.date,
                        className: 'ulg-report-cell ulg-report-assignments-cell ulg-report-assignments-cell--date',
                    },
                ];

            }
            tableVars.language = {
                processing:        groupAssignments.localized.processing,
                search:            '_INPUT_',
                searchPlaceholder: groupAssignments.localized.searchPlaceholder,
                lengthMenu:        groupAssignments.localized.lengthMenu,
                info:              groupAssignments.localized.info,
                infoEmpty:         groupAssignments.localized.infoEmpty,
                infoFiltered:      groupAssignments.localized.infoFiltered,
                infoPostFix:       '',
                loadingRecords:    groupAssignments.localized.loadingRecords,
                zeroRecords:       groupAssignments.localized.zeroRecords,
                emptyTable:        groupAssignments.localized.emptyTable,
                paginate: {
                    first:         groupAssignments.localized.paginate.first,
                    previous:      groupAssignments.localized.paginate.previous,
                    next:          groupAssignments.localized.paginate.next,
                    last:          groupAssignments.localized.paginate.last
                },
                aria: {
                    sortAscending:  groupAssignments.localized.sortAscending,
                    sortDescending: groupAssignments.localized.sortDescending
                }
            };
            tableVars.initComplete = function(s,d) {
                jQuery( `
                    <div class="group-assignments-buttons uo-hidden">
                        <button class="uo-btn uo-left" id="group-approve-assignments-button">
                            ${ groupAssignments.localized.approveAssignments }
                        </button>
                        <button class="uo-btn uo-left" id="group-trash-assignments-button">
                            ${ groupAssignments.localized.deleteAssignments }
                        </button>
                    </div>
                ` ).insertAfter( '.dt-search' );
                
                try {
                    // Insert column filter after search box
                    var $filterContainer = window.ulgmGroupManagement.Assignments.addColumnsFilter(s);
                    
                    var $searchBox = jQuery('.dt-search');
                    
                    // Insert after search box
                    if ($searchBox.length > 0 && $filterContainer.length > 0) {
                        $filterContainer.insertAfter($searchBox);
                    } else {
                        // Fallback - insert at the end of the datatable header
                        $filterContainer.appendTo('.uo-groups-datatable-header');
                    }
                    
                    // Ensure column visibility toggles are working with DataTables 2.x
                    jQuery('.dataTables-filter-columns input[type="checkbox"]').on('change', function() {
                        var columnIndex = jQuery(this).attr('id').replace('dt_', '');
                        var column = window.ulgmGroupManagement.Assignments.uoTable.column(columnIndex);
                        var isChecked = jQuery(this).is(':checked');
                        
                        column.visible(isChecked);
                    });
                    
                    // Add a class to make the customize columns UI visible
                    setTimeout(function() {
                        jQuery('.dataTables-filter-columns').addClass('dt-initialized');
                    }, 100);
                } catch (error) {
                    console.error('Error in initComplete:', error.message);
                }
            };

            // Check what column has to be used to sort the table
            let tableOrder = [];
            // Find the index of the column we have to use to sort
            let tableOrderByIndex = columns.findIndex( columnData => columnData.title == ulgmAssignmentReportShortcode.table.orderBy );

            // If the column doesn't exist, then try to get the default one
            if ( tableOrderByIndex === -1 ) {
                tableOrderByIndex = columns.findIndex( columnData => columnData.data == 'date' );
            }
            // If the one defined by the user, or the default one exists, add it
            if ( tableOrderByIndex !== -1 ) {
                tableOrder = [
                    [
                        tableOrderByIndex, // The ID of the column used to sort, defaults to `date`
                        ulgmAssignmentReportShortcode.table.order, // Designates the ascending or descending order of the 'orderby' parameter, defaults to `desc`
                    ]
                ];
            }

            tableVars.order = tableOrder;

            this.uoTable = jQuery('#uo-group-assignments-table');

            if ( jQuery('#uo-group-assignments-table').length > 0 ){
                try {
                    // Remove problematic properties for DataTables 2.x
                    if (tableVars.headerRows !== undefined) {
                        delete tableVars.headerRows;
                    }
                    
                    // Add ColReorder to the configuration
                    tableVars.colReorder = {
                        enable: true,
                        fixedColumnsLeft: 1  // Keep checkbox column fixed
                    };
                    
                    // Initialize DataTable with ColReorder included
                    this.uoTable = jQuery('#uo-group-assignments-table').DataTable(tableVars);
                    
                    // Verify ColReorder is available
                    if (!jQuery.fn.dataTable.ColReorder) {
                        console.warn('ColReorder extension not available despite being configured');
                    }
                } catch (error) {
                    console.error('Error initializing DataTable:', error.message);
                }
            }

        },

        createTableHidden: function (data) {

            var columns = [
                {title: groupAssignments.localized.title, data: 'title', className:'has-row-actions', name: 'title', visible: groupAssignments.columns_visibilities.title},
                {title: groupAssignments.localized.student, data: 'student', name: 'student', visible: groupAssignments.columns_visibilities.student},
                {title: groupAssignments.localized.first_name, data: 'first_name', name: 'first_name', visible: groupAssignments.columns_visibilities.first_name},
                {title: groupAssignments.localized.last_name, data: 'last_name', name: 'last_name', visible: groupAssignments.columns_visibilities.last_name},
                {title: groupAssignments.localized.author, data: 'author', name: 'author', visible: groupAssignments.columns_visibilities.author},
                {title: groupAssignments.localized.status, data: 'status', orderable: true, name: 'status', visible: groupAssignments.columns_visibilities.status},
                {title: groupAssignments.localized.points, data: 'points', orderable: false, name: 'points', visible: groupAssignments.columns_visibilities.points},
                {title: groupAssignments.localized.assignedCourse, data: 'assignedCourse',orderable: true, name: 'assignedCourse', visible: groupAssignments.columns_visibilities.assignedCourse},
                {title: groupAssignments.localized.assignedlesson, data: 'assignedlesson',orderable: true, name: 'assignedlesson', visible: groupAssignments.columns_visibilities.assignedlesson},
                {title: groupAssignments.localized.comments, data: 'comments', name: 'comments', visible: groupAssignments.columns_visibilities.comments},
                {title: groupAssignments.localized.date, data: 'date', name: 'date', visible: groupAssignments.columns_visibilities.date},
            ];

            /*var language = [
                "lengthMenu": groupAssignments.localized.lengthMenu,
                "zeroRecords": groupAssignments.localized.zeroRecords,
                "info": groupAssignments.localized.info,
                "infoEmpty": groupAssignments.localized.infoEmpty,
                "infoFiltered": groupAssignments.localized.infoFiltered,
                "loadingRecords": groupAssignments.localized.loadingRecords,
                "emptyTable": groupAssignments.localized.emptyTable
            ];*/
			var buttonCommon = {
				exportOptions: {
                    columns: ( id, data, node ) => {
                        // Don't export the column used to select rows, or
                        // "Title" columns
                        if (
                            node.matches( '.ulg-report-assignments-cell--select-row' ) ||
                            node.matches( '.ulg-report-assignments-cell--title' )
                        ) {
                            return false;
                        }

                        return this.uoTable.column( id ).visible();
                    },

					format: {
						body: function (data, row, column, node) {
							// Strips hidden timestamp <span>
							return data.replace(/\<span\s(?:class\=\"ulg\-hidden\-data\")(.*)\<\/span\>/g, '');
						}
					}
				}
			};
            var tableVars = {
                iDisplayLength: -1,
                columns: columns,
                dom: 'Bfrtip',
                buttons: [
					$.extend(true, {}, buttonCommon, {
						extend: 'csv',
						text: groupAssignments.localized.buttons.csvExport,
						title: 'lesson-report'
					})
                ],
                stateSave: true,
                //responsive: true,
            };

            if ($.fn.DataTable.isDataTable( '#uo-lesson-report-table-hidden' )) {

                $( '#uo-lesson-report-table-hidden' ).DataTable().destroy();

                tableVars.data = data;

                tableVars.columns = [
                    {title: groupAssignments.localized.title, data: 'title', name: 'title', visible: groupAssignments.columns_visibilities.title},
					{title: groupAssignments.localized.student, data: 'student', name: 'student', visible: groupAssignments.columns_visibilities.student},
                    {title: groupAssignments.localized.first_name, data: 'first_name', name: 'first_name', visible: groupAssignments.columns_visibilities.first_name},
                    {title: groupAssignments.localized.last_name, data: 'last_name', name: 'last_name', visible: groupAssignments.columns_visibilities.last_name},
                    {title: groupAssignments.localized.author, data: 'author', name: 'author', visible: groupAssignments.columns_visibilities.author},
                    {title: groupAssignments.localized.status, data: 'status', orderable: true, name: 'status', visible: groupAssignments.columns_visibilities.status},
                    {title: groupAssignments.localized.points, data: 'points', orderable: false, name: 'points', visible: groupAssignments.columns_visibilities.points},
                    {title: groupAssignments.localized.assignedCourse, data: 'assignedCourse',orderable: true, name: 'assignedCourse', visible: groupAssignments.columns_visibilities.assignedCourse},
                    {title: groupAssignments.localized.assignedlesson, data: 'assignedlesson',orderable: true, name: 'assignedlesson', visible: groupAssignments.columns_visibilities.assignedlesson},
                    {title: groupAssignments.localized.comments, data: 'comments', name: 'comments', visible: groupAssignments.columns_visibilities.comments},
                    {title: groupAssignments.localized.date, data: 'date', name: 'date', visible: groupAssignments.columns_visibilities.date},
                ];

            }

            tableVars.language = {
                processing:        groupAssignments.localized.processing,
                search:            '_INPUT_',
                searchPlaceholder: groupAssignments.localized.searchPlaceholder,
                lengthMenu:        groupAssignments.localized.lengthMenu,
                info:              groupAssignments.localized.info,
                infoEmpty:         groupAssignments.localized.infoEmpty,
                infoFiltered:      groupAssignments.localized.infoFiltered,
                infoPostFix:       '',
                loadingRecords:    groupAssignments.localized.loadingRecords,
                zeroRecords:       groupAssignments.localized.zeroRecords,
                emptyTable:        groupAssignments.localized.emptyTable,
                paginate: {
                    first:         groupAssignments.localized.paginate.first,
                    previous:      groupAssignments.localized.paginate.previous,
                    next:          groupAssignments.localized.paginate.next,
                    last:          groupAssignments.localized.paginate.last
                },
                aria: {
                    sortAscending:  groupAssignments.localized.sortAscending,
                    sortDescending: groupAssignments.localized.sortDescending
                }
            };

            if ( jQuery('#uo-lesson-report-table-hidden').length > 0 ){
                try {
                    // Remove problematic properties for DataTables 2.x
                    if (tableVars.headerRows !== undefined) {
                        delete tableVars.headerRows;
                    }
                    
                    // Add ColReorder to hidden table as well
                    tableVars.colReorder = {
                        enable: true
                    };
                    
                    this.uoTableHidden = jQuery('#uo-lesson-report-table-hidden').DataTable(tableVars);
                } catch (error) {
                    console.error('Error initializing hidden DataTable:', error.message);
                }
            }

            $('.buttons-csv').show();

        },

        flattenArray: function (array, remove_stats) {

            var flatArray = [];

            jQuery.each(array, function (key, value) {

                var lesson_name = value;
                jQuery.each(value.question, function (key2, value2) {
                    flatArray.push({
                        "title": value.title,
						"student": value.student,
                        "first_name": value.first_name,
                        "last_name": value.last_name,
                        "author": value.author,
                        "status": value.status,
                        "points": value.points,
                        "assignedCourse": value.assignedCourse,
                        "assignedlesson": value.assignedlesson,
                        "comments": value.comments,
                        "date": value.date,
                    })
                });

            });

            return flatArray;

        },
        addColumnsFilter: function (state) {
            var colFilter_container = $( `<div id="${ state.sInstance }-filter-columns" class="dataTables-filter-columns"><input class="dataTables-filter-columns-field" id="${ state.sInstance }-filter-columns-field" type="checkbox"><div class="dataTables-filter-columns__toggle"><label for="${ state.sInstance }-filter-columns-field" data-label-enable="${ groupAssignments.localized.customizeColumns }" data-label-disable="${ groupAssignments.localized.hideCustomizeColumns }"></label></div><div class="dataTables-filter-columns__fields"></div></div>` );
            __this = window.ulgmGroupManagement.Assignments;
            
            try {
                // DataTables 2.x uses different property structure
                // First try DataTables 2.x structure
                if (state.aoColumns) {
                    jQuery.each(state.aoColumns, function (key, value) {
                        if (key > 0) {
                            var title = value.sTitle;
                            var visible = value.bVisible;
                            colFilter_container.find('.dataTables-filter-columns__fields').append(__this.addColumnCheckbox(title, key, visible));
                        }
                    });
                } 
                // Fallback to saved state if available
                else if (state.oSavedState && state.oSavedState.columns) {
                    jQuery.each(state.oSavedState.columns, function (key, value) {
                        if (key > 0) {
                            // Find the column title from the table header
                            var title = jQuery('#uo-group-assignments-table th').eq(key).text();
                            var visible = value.visible;
                            colFilter_container.find('.dataTables-filter-columns__fields').append(__this.addColumnCheckbox(title, key, visible));
                        }
                    });
                }
                // As a last resort, get columns directly from API
                else if (__this.uoTable) {
                    var columns = __this.uoTable.settings().init().columns;
                    jQuery.each(columns, function (key, value) {
                        if (key > 0) {
                            var title = value.title;
                            var visible = value.visible !== false;
                            colFilter_container.find('.dataTables-filter-columns__fields').append(__this.addColumnCheckbox(title, key, visible));
                        }
                    });
                }
            } catch (error) {
                console.error('Error building column filter:', error.message);
            }

            return colFilter_container;
        },
        addColumnCheckbox: function (label, column_key, is_visible) {
            var checkbox = jQuery('<input />', {
                type: 'checkbox',
                id: 'dt_' + column_key,
                value: label,
                checked: is_visible
            });
            checkbox.on('change', function (e) {
                // Get the column API object
                var headers = window.ulgmGroupManagement.Assignments.uoTable.columns().header();
                var current_check = jQuery(this).attr('value');
                var is_checked = jQuery(this).is(':checked');

                jQuery.each(headers, function (key, selectot) {
                    if (jQuery(selectot).html() === current_check) {
                        var column = window.ulgmGroupManagement.Assignments.uoTable.column(key);
                        if (is_checked) {
                            // Toggle the visibility
                            column.visible(true);
                        } else {
                            column.visible(false);
                        }
						// Trigger Resize
						window.ulgmGroupManagement.Assignments.uoTable.columns.adjust().recalc();
                    }
                });

            });
            var $label = jQuery('<label/>').append(checkbox).append(label);
            return $label;
        },
        create_options: function( source, ids ){
            /*
            * @param source string, values "group", "course", "lesson"
            * @param ids    array,  ids of options that have to be shown
            *
            * @return array of jQuery DOM elements with the option elements
            */

            let options = [];

            // Convert parameters to int
            ids = ids.map( Number );

            // Add empty option
            // if there are more then one option
            if( ids.length > 1 ){
                ids.push(0);
            }


            // Get options by ID
            this.elements.select[source].options.each(function(){
                let $this   = $(this),
                    id      = parseInt( $this.val() );
                $this.show();
                if ( ids.indexOf( id ) != -1 ){
                    options.push( $this );
                }
            });

            // Return options
            return options;
        },

        select_option: function( $select, value ){
            /*
            * @param select  dom element
            * @param value   string, value of the option that has to be selected
            */

            // Remove selected property
            $select.find( 'option' ).prop( 'selected', false );

            // Select option with value = @param value
            $select.find( 'option[value="' + value + '"]' ).prop( 'selected', true );
        },
        __select_option: function( $select, index ){
            /*
            * @param select  dom element
            * @param value   string, value of the option that has to be selected
            */

            // Remove selected property
            $select.find( 'option' ).prop( 'selected', false );

            // Select option with value = @param value
            $select.find( 'option[' + index + ']' ).prop( 'selected', true );
        },
        addEvents: function (){
            var _this = this;

            // Handle click on "Select all" control
            $('#uo-groups-assignments-management').on('click','#uo-assignments-select-all', function(){
                // Check/uncheck checkboxes for all rows in the table
                $('input[name="post[]"]').prop('checked', this.checked);
                if ($('input[name="post[]"]').is(':checked')) {
                    $('.group-assignments-buttons').show();
                } else {
                    $('.group-assignments-buttons').hide();
                    $('#uo-assignments-select-all').prop('checked', false);
                }
            });

            // Handle click on checkbox to set state of "Select all" control
            $('#uo-group-assignments-table tbody').on('change', 'input[name="post[]"]', function(){
                // If checkbox is not checked
                if(!this.checked){
                    var el = $('#uo-assignments-select-all').get(0);
                    // If "Select all" control is checked and has 'indeterminate' property
                    if(el && el.checked && ('indeterminate' in el)){
                        // Set visual state of "Select all" control
                        // as 'indeterminate'
                        el.indeterminate = true;
                    }
                }
                if ($('input[name="post[]"]').is(':checked')) {
                    $('.group-assignments-buttons').show();
                } else {
                    $('.group-assignments-buttons').hide();
                    $('#uo-assignments-select-all').prop('checked', false);
                }
            });

            $('#uo-groups-assignments-management').on('click','#group-approve-assignments-button',function(){
                if (jQuery('form#uo-groups-assignments-management-form input#bulk-action-selector-top').length) {
                    jQuery('form#uo-groups-assignments-management-form input#bulk-action-selector-top').val('approve_assignment');
                }
                //jQuery('form#uo-groups-assignments-management-form').submit();
            });

            $('#uo-groups-assignments-management').on('click','#group-trash-assignments-button',function(){
                if (jQuery('form#uo-groups-assignments-management-form input#bulk-action-selector-top').length) {
                    jQuery('form#uo-groups-assignments-management-form input#bulk-action-selector-top').val('trash_assignment');
                }
                //jQuery('form#uo-groups-assignments-management-form').submit();

            });

            this.elements.select.group.element.on('change', function(){
                // Save this DOM element
                let $this = $(this);

                // Hide lesson select
                //_this.elements.select.lesson.element.hide();
                _this.elements.select.course.element.show();

                // Group ID
                let group_id = $this.val();
                // Return if course id is 0
                if( group_id == 0 || group_id == null ){
                    _this.elements.select.course.element.empty();
                    let options_course = _this.create_options( 'course', [0] );
                    _this.elements.select.course.element.html(options_course);
                    _this.elements.select.course.element.attr('disabled','disabled');
                    _this.elements.select.lesson.element.empty();
                    let options = _this.create_options( 'lesson', [0] );
                    _this.elements.select.lesson.element.html(options);
                    _this.elements.select.lesson.element.attr('disabled','disabled');
                    window.ulgmGroupManagement.Assignments.createTable([]);
                    window.ulgmGroupManagement.Assignments.createTableHidden([]);
                    return;
                }
                // Get relationships
                let courses_to_show = groupAssignments.courseGrouplessons[ group_id ];
                courses_to_show = courses_to_show === undefined ? [] : courses_to_show;

                // Create options
                let options = _this.create_options( 'course', courses_to_show );

                if ( options.length > 0 ){
                     // Show "Select course" dropdown
                    _this.elements.select.course.element.show();
                    _this.elements.select.course.element.html( options );
                    _this.elements.select.course.no_element.hide();
                    //_this.elements.select.course.element.html(_this.elements.select.course.element.find('option').sort(function(x, y) {
                        // to change to descending order switch "<" for ">"
                    //    return $(x).text() > $(y).text() ? 1 : -1;
                    //}));
                    _this.elements.select.course.element.removeAttr('disabled');

                    // Select empty option

                    _this.__select_option( _this.elements.select.course.element, 0 );

                    // Save data in main object
                    window.ulgmGroupManagement.Assignments.groupId = group_id;
                    // trigger change after value set on load
                    _this.elements.select.course.element.trigger('change');
                }
                else {
                    // Hide "Select course" dropdown, the empty option was selected
                    _this.elements.select.course.element.empty();
                    let options_course = _this.create_options( 'course', [0] );
                    _this.elements.select.course.element.html(options_course);
                    _this.elements.select.course.element.attr('disabled','disabled');
                    _this.elements.select.lesson.element.empty();
                    let options = _this.create_options( 'lesson', [0] );
                    _this.elements.select.lesson.element.html(options);
                    _this.elements.select.lesson.element.attr('disabled','disabled');
                    window.ulgmGroupManagement.Assignments.createTable([]);
                    window.ulgmGroupManagement.Assignments.createTableHidden([]);
                    // Save data in main object
                    window.ulgmGroupManagement.Assignments.groupId = group_id;
                }
                // Request data
                window.ulgmGroupManagement.Assignments.getAssignmentsData( 0, 0, window.ulgmGroupManagement.Assignments.groupId, window.ulgmGroupManagement.Assignments.status );
            });

            this.elements.select.course.element.on('change', function(){
                // Save this DOM element
                let $this = $(this);

                // Course ID
                let course_id = $this.val();
                // Return if course id is 0
                if( course_id == 0){
                    _this.elements.select.lesson.element.empty();
                    let options = _this.create_options( 'lesson', [0] );
                    _this.elements.select.lesson.element.html(options);
                    _this.elements.select.lesson.element.attr('disabled','disabled');
                    window.ulgmGroupManagement.Assignments.createTable([]);
                    window.ulgmGroupManagement.Assignments.createTableHidden([]);
                    return;
                }

                // Get relationships
                let lessons_to_show = groupAssignments.relationships[ window.ulgmGroupManagement.Assignments.groupId ][ course_id ];
                lessons_to_show = lessons_to_show === undefined ? [] : lessons_to_show;

                // Create options
                let options = _this.create_options( 'lesson', lessons_to_show );

                if ( options.length > 0 ) {
                    // Show "Select lesson" dropdown
                    _this.elements.select.lesson.element.show();
                    _this.elements.select.lesson.element.html(options);
                    jQuery('#uo-group-report-lessons option').show();
                    _this.elements.select.lesson.no_element.hide();

                    // Select empty option
                    _this.__select_option( _this.elements.select.lesson.element, 0 );
                    _this.elements.select.lesson.element.removeAttr('disabled');

                    // Save data in main object
                    window.ulgmGroupManagement.Assignments.courseId = course_id;
                    // trigger change after value set on load
                    _this.elements.select.lesson.element.trigger('change');
                }else{
                    // Hide "Select course" dropdown, the empty option was selected
                    _this.elements.select.lesson.element.empty();
                    let options = _this.create_options( 'lesson', [0] );
                    _this.elements.select.lesson.element.html(options);
                    _this.elements.select.lesson.element.attr('disabled','disabled');
                    window.ulgmGroupManagement.Assignments.createTable([]);
                    window.ulgmGroupManagement.Assignments.createTableHidden([]);
                    // Save data in main object
                    window.ulgmGroupManagement.Assignments.courseId = course_id;
                    // Request data
                    window.ulgmGroupManagement.Assignments.getAssignmentsData( 0, window.ulgmGroupManagement.Assignments.courseId, window.ulgmGroupManagement.Assignments.groupId, window.ulgmGroupManagement.Assignments.status );
                }

            });

            this.elements.select.lesson.element.on('change', function(){
                // Save this DOM element
                let $this = $(this);

                // lesson ID
                let lesson_id = $this.val();
                // Save data in main object
                window.ulgmGroupManagement.Assignments.lessonId = lesson_id;

                // Request data
                window.ulgmGroupManagement.Assignments.getAssignmentsData( lesson_id, window.ulgmGroupManagement.Assignments.courseId, window.ulgmGroupManagement.Assignments.groupId, window.ulgmGroupManagement.Assignments.status );
            });

            this.elements.select.status.element.on('change', function(){
                // Save this DOM element
                let $this = $(this);

                // lesson ID
                let status = $this.val();
                // Save data in main object
                window.ulgmGroupManagement.Assignments.status = status;

                // Request data
                window.ulgmGroupManagement.Assignments.getAssignmentsData( window.ulgmGroupManagement.Assignments.lessonId, window.ulgmGroupManagement.Assignments.courseId, window.ulgmGroupManagement.Assignments.groupId, status );
            });

            // Add event listener for opening and closing details
            $('#uo-lesson-report-table').on('click', 'td.details-control', function () {

                var tr = $(this).closest('tr');
                var row = window.ulgmGroupManagement.Assignments.uoTable.row(tr);

                if (row.child.isShown()) {
                    // This row is already open - close it
                    row.child.hide();
                    tr.removeClass('shown');
                }
                else {
                    // Open this row
                    row.child(window.ulgmGroupManagement.Assignments.format(row.data())).show();
                    tr.addClass('shown');
                }
            });

        },

        format: function (d) {

            var rows = '';
            $.each(d.answer, function (key, value) {
                rows +=
                    '<tr>' +
                    '<td>' + d.question[key] + '</td>' +
                    '<td>' + value + '</td>' +
                    '</tr>';
            });
            // `d` is the original data object for the row
            return '<table cellpadding="5" cellspacing="0" border="0" style="padding-left:50px;">' + rows + '</table>';
        },
        isNormalInteger: function (str) {
            var n = ~~Number(str);
            return String(n) === str && n > 0;
        },

        getAssignmentsData: function (lessonId, courseId, groupId, status) {
            var spinner = $('.uo-modal-spinner');
            spinner.show();
            var i = 0;

            var loading = setInterval(function () {
                i = ++i % 4;
                $("#uo-group-assignments-table tbody").html("<div id='group-loader'>" + groupAssignments.localized.loadingRecords + new Array(i + 1).join(".") + "</div>");
            }, 500);


            var dataVars = {
                groupId: groupId,
                lessonId: lessonId,
                courseId: courseId,
                status: status,
            };

            $.ajax({

                method: "POST",
                data: dataVars,
                url: groupAssignments.root + 'get_assignments_data/',
                beforeSend: function (xhr) {
                    xhr.setRequestHeader('X-WP-Nonce', groupAssignments.nonce);
                },
                success: function (response) {
                    spinner.hide();
                    clearInterval(loading);
                    $('#group-loader').remove();

                    window.ulgmGroupManagement.Assignments.createTable(response);
                    window.ulgmGroupManagement.Assignments.createTableHidden(response);


                },
                fail: function (response) {
                    alert('Rest Call Failed');
                }

            });

        },
        editAssignmentsData: function (postId) {
            var spinner = $('.uo-modal-spinner');
            spinner.show();
            var dataVars = {
                assignment_id: postId,
                action: 'edit_assignments',
                post_type:'sfwd-assignment',
                security:groupAssignments.ajax_nonce
            };

            $.ajax({
                method: "POST",
                data: dataVars,
                url: groupAssignments.root + 'edit_assignments_data/',
                beforeSend: function (xhr) {
                    xhr.setRequestHeader('X-WP-Nonce', groupAssignments.nonce);
                },
                success: function (response) {
                    spinner.hide();
                    $(".modal").remove();

                    const modal = $(response.html);

                    modal.appendTo( 'body' );

                    modal.on( 'modal:open.uncanny-groups-modal', () => {
                        // Focus on the first field
                        const fieldField = $( modal ).find( 'input:visible, select:visible' ).first();
                        
                        if ( fieldField.length > 0 ) {
                            fieldField.trigger( 'focus' );
                        } else {
                            $( modal ).find( 'button:visible:first' ).trigger( 'focus' );
                        }

                        modal.off( 'modal:open.uncanny-groups-modal' );
                    } );

                    modal.modal();
                },
                fail: function (response) {
                    spinner.hide();
                    alert('Rest Call Failed');
                }
            });
        },
        saveAssignmentsData: function () {
            var dataVars = $('#edit_assignment_form').serialize();
            var spinner = $('.uo-modal-spinner');
            //$('#group-management-message').hide();
            $('.uo-groups-message-ok').hide();
            spinner.show();
            $.ajax({
                method: "POST",
                data: dataVars,
                url: groupAssignments.root + 'save_assignments_data/',
                beforeSend: function (xhr) {
                    xhr.setRequestHeader('X-WP-Nonce', groupAssignments.nonce);
                },
                success: function (response) {
                    spinner.hide();
                    window.ulgmGroupManagement.Assignments.elements.select.lesson.element.trigger('change');
                    //$('#group-management-message').html(response.message).show();
                    $('.uo-groups-message-ok').html(response.message).show();
                },
                fail: function (response) {
                    spinner.hide();
                    alert('Rest Call Failed');
                }
            });
        },
        actionsAssignment: function ( dataVars ) {
            var spinner = $('.uo-modal-spinner');
            spinner.show();
            $.ajax({
                method: "POST",
                data: dataVars,
                url: groupAssignments.root + 'save_assignments_data/',
                beforeSend: function (xhr) {
                    xhr.setRequestHeader('X-WP-Nonce', groupAssignments.nonce);
                },
                success: function (response) {
                    spinner.hide();
                    window.ulgmGroupManagement.Assignments.elements.select.lesson.element.trigger('change');
                },
                fail: function (response) {
                    spinner.hide();
                    alert('Rest Call Failed');
                }
            });
        }
    };


})(jQuery);
